import getPlansByProductId from 'core/services/getPlansByProductId'
import {
  DENTAL,
  VISION,
  LATITUDE,
  ECONOMY,
  QUANTUM,
  DELUXE,
  STANDARD,
  CORE,
  CHOICE,
  EPIC,
  SUPPLEMENTAL_BENEFIT,
  SURE_CARE
} from 'core/constants/products'

const products = [
  DENTAL,
  VISION,
  LATITUDE,
  ECONOMY,
  QUANTUM,
  DELUXE,
  STANDARD,
  CORE,
  CHOICE,
  EPIC,
  SUPPLEMENTAL_BENEFIT,
  SURE_CARE
]

export type Rules = Record<number, boolean | (() => boolean)>

const rulesFilter = (rules: Rules) => (product: number) => {
  if (rules[product] != null)
    return typeof rules[product] === 'function' ? rules[product]() : rules[product]

  return true
}

/**
 * getPlansByCustomRules - Function based on getPlansByProductId that filters products based on custom rules.
 * Each rule is a key-value pair where the key is the product id and the value is a boolean or a function that returns a boolean.
 * If the value is a function, it will be called and the result will be used as the value.
 * @param store - The Pivot.Store instance.
 * @param rules - The rules to filter the products.
 * @returns - The getQuote response based on the filtered products.
 */
function getPlansByCustomRules(store: Pivot.Store, rules: Rules = {}) {
  return getPlansByProductId(
    {
      products: products.filter(rulesFilter(rules))
    },
    store
  )
}

export default getPlansByCustomRules
